export default __webpack_public_path__ + "static/media/obs.4c488394.png";